import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schematic-new',
  templateUrl: './schematic-new.component.html',
  styleUrls: ['./schematic-new.component.scss']
})
export class SchematicNewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
